<template>
  <button
    type="button"
    :disabled="isDisabled || isLoading"
    :class="[
      'relative flex h-8 items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-1',
      isDisabled || isLoading ? 'pointer-events-none cursor-not-allowed opacity-60' : 'cursor-pointer',
      isSquared ? 'rounded-(--button-radius)' : 'rounded-full',
      label
        ? [
            'group min-w-8 overflow-hidden',
            isExpanded
              ? 'gap-1.5 pl-4 pr-6'
              : [
                  'max-w-8 gap-0 px-0',
                  'transition-[max-width,padding,gap] duration-200',
                  'hover:max-w-48 hover:gap-1.5 hover:pl-4 hover:pr-6 focus-visible:max-w-48 focus-visible:gap-1.5 focus-visible:pl-4 focus-visible:pr-6',
                ],
            variant === 'primary'
              ? 'bg-action text-white'
              : variant === 'secondary-dark'
                ? 'bg-surface-sunken text-text-secondary'
                : 'bg-surface-muted text-text-secondary',
          ]
        : [
            'w-8 transition-colors',
            variant === 'primary'
              ? 'bg-action text-white'
              : variant === 'secondary-dark'
                ? active
                  ? 'bg-border-subtle text-text-secondary'
                  : 'bg-surface-sunken text-text-secondary hover:bg-border-subtle'
                : active
                  ? 'bg-surface-sunken text-text-secondary'
                  : 'bg-surface-muted text-text-secondary hover:bg-surface-sunken',
          ],
    ]">
    <IconLucideLoaderCircle
      v-if="isLoading"
      class="h-4 w-4 shrink-0 animate-spin" />
    <slot v-else />
    <span
      v-if="label"
      :class="[
        'overflow-hidden text-sm font-medium whitespace-nowrap',
        isExpanded
          ? 'max-w-full'
          : 'max-w-0 transition-[max-width] duration-200 group-hover:max-w-full group-focus-visible:max-w-full',
      ]">
      {{ label }}
    </span>
    <span
      v-if="count > 0"
      class="pointer-events-none absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-action text-[8px] leading-none font-semibold text-white">
      {{ displayCount }}
    </span>
  </button>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'IconButton',

  props: {
    label: { type: String, default: undefined },
    variant: {
      type: String as PropType<'primary' | 'secondary' | 'secondary-dark'>,
      default: 'secondary',
    },
    active: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
    isSquared: { type: Boolean, default: false },
    isExpanded: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },

  computed: {
    displayCount(): number {
      return Math.min(this.count, 9)
    },
  },
}
</script>

